/** Событие для страниц без React Query (чаты, ручная загрузка). */
export const ADMIN_REFRESH_EVENT = "tezam-admin-data-refresh";

export function dispatchAdminDataRefresh(): void {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new Event(ADMIN_REFRESH_EVENT));
}
